<template>
    <button
        type="button"
        class="shrink-0 rounded-full p-1 leading-none text-valence-stone-500 transition-colors hover:text-valence-stone-900"
        :aria-expanded="expanded"
        aria-haspopup="dialog"
        :aria-label="expanded ? `Hide info about ${topic}` : `Show info about ${topic}`"
        @click="onToggle">
        <i class="bi bi-info-circle text-xs" aria-hidden="true"></i>
    </button>
</template>

<script setup lang="ts">
interface Props {
    expanded: boolean;
    topic: string;
}

defineProps<Props>();
const emit = defineEmits<{ (event: "toggle"): void }>();

function onToggle() {
    emit("toggle");
}
</script>
